import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../../App.css";
import React, { useState, useRef, useEffect, useMemo, useCallback, memo } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { motion } from "framer-motion";
import { LicenseManager } from "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import "ag-grid-community/styles/ag-theme-material.css";
import Footer from "../Footer/Footer";
import GLOBALS from "../../utils/Globals";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import JsonView from "react18-json-view";
import "react18-json-view/src/style.css";
import Button from "react-bootstrap/Button";
import Collapse from "react-bootstrap/Collapse";


LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-067893}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{nutrad}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{nutrad_portal}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{nutrad_portal}_need_to_be_licensed___{nutrad_portal}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{29_October_2025}____[v3]_[01]_MTc2MTY5NjAwMDAwMA==71e88be6064d0b1886823ed0ecdbe20c"
);

function Jobs() {
  const [rowData, setRowData] = useState();

  const [job_id, setJob_id] = React.useState(null);
  const [status, setStatus] = React.useState(null);
  const [created_at, setCreated_At] = React.useState(null);

  const [open, setOpen] = useState(false);

  const [selectedRowData, setSelectedRowData] = useState(null);

  const [state, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  

  useEffect(() => {
    const baseURLGetJobs =
      process.env.REACT_APP_ENV === "PROD"
        ? GLOBALS.PROD.baseURLGetJobs
        : GLOBALS.DEV.baseURLGetJobs;

    fetch(baseURLGetJobs)
      .then((result) => result.json())
      .then((rowData) => setRowData(rowData));
  }, []);

  console.log(rowData);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      editable: false,
      //filter: true
    };
  });

  const onRowDoubleClicked = useCallback((event) => {
    setSelectedRowData(event.data);
    setJob_id(event.data.job_id);
    setStatus(event.data.status);
    setCreated_At(event.data.created_at);
    console.log(selectedRowData)
    setState({ isPaneOpen: true });
  }, []);

  const [colDefs, setColDefs] = useState([
    {
      field: "job_id",
      headerName: "ID",
      filter: "agTextColumnFilter",
    },
    {
      field: "type",
      headerName: "Type",
      filter: "agTextColumnFilter",
    },
    {
      field: "status",
      headerName: "Status",
      filter: "agTextColumnFilter",
    },
    {
      field: "created_at",
      headerName: "Created At",
      filter: "agTextColumnFilter",
    },
  ]);

  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: false,
    };
  }, []);

  if (!rowData) return null;

  return (
    <>
      <br></br>
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-xl font-semibold text-gray-900">
              Current Jobs
            </h1>

            <br></br>
          </div>
        </div>
        <div
          className="ag-theme-material" // applying the Data Grid theme
          style={{ height: 800 }}
        >
          <AgGridReact
            rowData={rowData}
            animateRows={true}
            columnDefs={colDefs}
            rowSelection={rowSelection}
            //rowClassRules={rowClassRules}
            pagination={true}
            onRowDoubleClicked={onRowDoubleClicked}
            paginationPageSize={10}
            paginationPageSizeSelector={[10, 20]}
            defaultColDef={defaultColDef}
          />
        </div>
        <SlidingPane
          className="some-custom-class"
          overlayClassName="some-custom-overlay-class"
          isOpen={state.isPaneOpen}
          title="Job Details"
          onRequestClose={() => {
            // triggered on "<" on left top click or on outside click
            setState({ isPaneOpen: false });
          }}
        >
          <br />
          <div>Job Details</div>
          <motion.form
            //onSubmit={handleSubmit}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="bg-white shadow-md rounded-xl p-6 space-y-4"
          >
            <div className="grid md:grid-cols-2 gap-4">
              <motion.div
                whileFocus={{ scale: 1.02 }}
                className="col-span-full relative"
              >
                <label>
                  ID:
                  <input
                    type="text"
                    id="gln"
                    value={job_id}
                    //onChange={handleChange}
                    className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                    placeholder="GLN"
                    required
                  />
                </label>
                <br></br>
                <label>
                  Status:
                  <input
                    type="text"
                    id="gln"
                    value={status}
                    //onChange={handleChange}
                    className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                    placeholder="GLN"
                    required
                  />
                </label>
                <br></br>
                <label>
                  Created At:
                  <input
                    type="text"
                    id="ca"
                    value={created_at}
                    //onChange={handleChange}
                    className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                    placeholder="GLN"
                    required
                  />
                </label>
                <br></br>
                <br></br>
                <Button
                  variant="outline-primary"
                  onClick={() => setOpen(!open)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                >
                  Show Job Details
                </Button>
                <br></br>
                <br></br>
                <Collapse in={open}>
                  <div id="example-collapse-text">
                    <JsonView src={selectedRowData} />
                  </div>
                </Collapse>

                <br></br>
              </motion.div>
            </div>
          </motion.form>
        </SlidingPane>
      </div>

      <Footer />
    </>
  );
}

export default Jobs;
